import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./Products.module.css";

const Products = () => {
  const handleWhatsAppClick = () => {
    const message = "Hi, I'm interested in learning more about STEMx products.";
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const whatsappUrl = isMobile
      ? `whatsapp://send?text=${encodeURIComponent(message)}`
      : `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <section className={styles.products}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Our Products and Services</h2>
        <div className={styles.content} data-aos="fade-up">
          <p>
            We are a technology oriented company adapting to the latest
            developments in the fast paced robotics field. Our R&D team works
            hard to keep the curriculum and labs updated with these
            developments.
          </p>
          <p>
            The curriculum for school is tailored to suit the requirements of
            CBSE, ICSE, IB, NCERT, Cambridge University and the Australian board
            of education.
          </p>
          <div className={styles.links}>
            <Link to="/products" className={styles.link}>
              View Our Products
            </Link>
            <Link to="/school-programmes#services" className={styles.link}>
              Explore Our Services
            </Link>
            <button
              onClick={handleWhatsAppClick}
              className={`${styles.link} ${styles.whatsappButton}`}
            >
              <FaWhatsapp /> <span className={styles.highlight}>Chat</span> with
              us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
